<template>
  <div class="grid-view charge-search-tab">
    <div class="main-content" style="overflow-y: auto;">
      <div class="section grid-wrapper">
        <cargo-ag-grid-wrapper
          config-module="185011"
          :grid-options="gridOptions"
          :export-file-name="$t(filename)"
          :column-defs="columnDefs"
          :row-data="rowData"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :show-row-groups="dataListDragGroup"
        />
      </div>
      <div id="footer-wrapper" class="pagination-wrapper amount-sum" style="flex-wrap: unset;align-items: unset;padding: 2px 5px;line-height: 28px;">
        <div style="display: flex;flex-direction: row-reverse;min-width: 600px">
          <charge-amount-sum-by-currency
            key="amountSumByCurrency"
            :data-provider="dataProvider"
            ar-field="ACCOUNT_RECEIVABLE"
            cache-prefix="ChargeTab"
            @callback="onSumCallbak"
          />
          <amount-sum-master-bold
            key="sumJobEquivalentRMB"
            ref="sumJobEquivalentRMB"
            datafield="EQUIVALENT_RMB"
            :title="$t('CargoMsg.Cargo_ConversionProfitCNYP')"
            :data-provider="rowData"
          />
          <amount-sum-master-bold
            key="sumJobRmbEquivalentPayable"
            ref="sumJobRmbEquivalentPayable"
            datafield="rmbEquivalentPayable"
            :title="$t('CargoMsg.Cargo_ConversionAPCNY') + ':'"
            :data-provider="rowData"
          />
          <amount-sum-master-bold
            key="sumJobRmbEquivalentReceiveable"
            ref="sumJobRmbEquivalentReceiveable"
            datafield="rmbEquivalentReceiveable"
            :title="$t('CargoMsg.Cargo_ConversionARCNY') + ':'"
            :data-provider="rowData"
          />
        </div>
        <!-- <amount-sum-master
          key="sumChargeUnpaid"
          ref="sumChargeUnpaid"
          datafield="AMOUNT_UN"
          :has-muti-currency="true"
          ar-data-field="ACCOUNT_RECEIVABLE"
          :is-ar="false"
          :data-provider="rowData"
          :is-sum-visible="false"
          :title="$t('CargoMsg.Cargo_OutstandingAPP')"
        />
        <amount-sum-master
          key="sumChargePayable"
          ref="sumChargePayable"
          datafield="VERIFIED_AMOUNT"
          :has-muti-currency="true"
          ar-data-field="ACCOUNT_RECEIVABLE"
          :is-ar="false"
          :data-provider="rowData"
          :is-sum-visible="false"
          :title="$t('CargoMsg.Cargo_APWrittenOffP')"
        />
        <amount-sum-master
          key="sumChargeNotReceived"
          ref="sumChargeNotReceived"
          datafield="AMOUNT_UN"
          :has-muti-currency="true"
          ar-data-field="ACCOUNT_RECEIVABLE"
          :is-ar="true"
          :data-provider="rowData"
          :is-sum-visible="false"
          :title="$t('CargoMsg.Cargo_ARNotWrittenOffP')"
        />
        <amount-sum-master
          key="sumChargeReceivable"
          ref="sumChargeReceivable"
          datafield="VERIFIED_AMOUNT"
          :has-muti-currency="true"
          ar-data-field="ACCOUNT_RECEIVABLE"
          :is-ar="true"
          :data-provider="rowData"
          :title="$t('CargoMsg.Cargo_ARWrittenOffP')"
        /> -->
        <div style="flex-grow: 1;display: inline-flex;flex-wrap: wrap;">
          <template v-if="!showSumPop">
            <div style="display: inline-flex;flex-wrap: wrap;">
              <span>{{ $t('FinanceManage.CurrencyAccountsReceivable') }}</span>
              <div v-for="(item,index) in arCurrencySum" :key="index">
                <span style="padding-right: 8px;">{{ item.currency }}</span>
                <span style="padding-right: 8px;color:gray;">{{ item.amount.toFixed(2) }}</span>
              </div>
            </div>
            <div style="display: inline-flex;flex-wrap: wrap;">
              <span>{{ $t('FinanceManage.CurrencyAccountsPayable') }}</span>
              <div v-for="(item,index) in apCurrencySum" :key="index">
                <span style="padding-right: 8px;">{{ item.currency }}</span>
                <span style="padding-right: 8px;color:gray;">{{ item.amount.toFixed(2) }}</span>
              </div>
            </div>
          </template>
        </div>
        <div style="display: inline-flex;min-width: 150px">
          <div>{{ $t('CargoMsg.Cargo_AllAmountP')+rowData.length }}</div>
          <div style="margin: 0px 10px;">{{ $t('CargoMsg.Cargo_SelectedItems',['['+numSelected+']']) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import AmountSumMasterBold from './AmountSumMasterBold'
import ChargeAmountSumByCurrency from './ChargeAmountSumByCurrency'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { getJumpFinaceOrBusinessAttrs } from '@/components/Cargo/grid/routerAndPrintHelp'
import CargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { cache, cacheName } from '@/utils/cacheManager'
import { stringToBool } from '@/utils/commonUtil'

export default {
  name: 'ChargeTab',
  components: { CargoAgGridWrapper, AmountSumMasterBold, ChargeAmountSumByCurrency },
  props: {
    filename: { type: String, default: '' },
    data: { type: Array, required: true },
    rowDataChanged: {
      type: Function, default: () => {
      }
    },
    perConfigName: { type: String, default: '' },
    gridRefreshId: { type: Number, default: 0 }
  },
  data() {
    return {
      loading: false,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: this.rowDataChanged,
        context: {
          componentParent: this
        }
      },
      columnDefs: [],
      rowData: [],
      dataProvider: [],
      numSelected: 0,
      showSumPop: false, // 是否显示合计弹窗
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      arCurrencySum: [],
      apCurrencySum: []
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    data(newVal) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'UUID')
      this.rowData = newVal
      this.dataProvider = this.rowData
      selectedStatus.revert()
    }
  },
  created() {
    this.rowData = this.data
    this.dataProvider = this.rowData
    this.initConfig()
  },
  beforeMount() {
    this.gridOptions.onSelectionChanged = (event) => {
      this.onCheckBoxClick(event)
    }
    this.columnDefs = [
      {
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'JOB_NO', width: 180,
        cellRendererFramework: 'agGridColumnEdit',
        custom: {
          tag: 'router-and-print',
          attrs: params => {
            const data = params.data
            return getJumpFinaceOrBusinessAttrs(true, false, data.JOB_NO, data.lob, data.BRANCH_ID)
          }
        }},
      { headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'), field: 'CUSTOMER_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        } },
      { headerName: this.$t('CargoMsg.Cargo_MblNo'), field: 'MBL', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'ACCOUNT_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId')
        } },
      { headerName: this.$t('CargoMsg.Cargo_VesselAndVoyage'), field: 'VOYAGE_FLIGHT', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.vesselVoyageLabelFunc(params.data)
        },
        filter: false,
        filterParams: {}
      },
      { headerName: this.$t('CargoMsg.Cargo_CustomerReferenceNumber'), field: 'CUSTOMER_REF_NO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_PortOfLoading'), field: 'LOADING_PORT_CODE', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.portLabelFuncByFinance(params.data, params.value)
        },
        filter: false,
        filterParams: {}
      },
      { headerName: this.$t('CargoMsg.Cargo_Sales'), field: 'SALES_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        } },
      { headerName: this.$t('CargoMsg.Cargo_DestinationPort'), field: 'DESTINATION_PORT_CODE', width: 180,
        cellRenderer: (params) => {
          if (params.data.lob === 'SI') {
            return ColumnUtils.portLabelFuncByFinance(params.data, params.data.DISCHARGING_PORT_CODE)
          }
          return ColumnUtils.portLabelFuncByFinance(params.data, params.value)
        },
        filter: false,
        filterParams: {}
      },
      { headerName: this.$t('CargoMsg.Cargo_ChargeName'), field: 'CHARGEITEMID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
        } },
      { headerName: this.$t('CargoMsg.Cargo_AROrNot'), field: 'ACCOUNT_RECEIVABLE', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_TaxIncludedPrice'), field: 'AMOUNT', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_TaxExcludedPrice'), field: 'EXCLUDING_TAX_AMOUNT', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_TaxAmount'), field: 'TAX_AMOUNT', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_TaxRate'), field: 'TAX_RATE', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        } },

      { headerName: this.$t('CargoMsg.Cargo_InvoiceNo'), field: 'INVOICE_NO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'BILL_NO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_PaymentApplicationNo'), field: 'PAYMENT_NO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_WrittenOff'), field: 'VERIFIED_AMOUNT', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotWrittenOff'), field: 'AMOUNT_UN', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('SeaExport.CustomJobType'), field: 'CUSTOM_JOB_TYPE', width: 180, enableRowGroup: true,
        valueGetter: (params) => {
          return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.CUSTOM_JOB_TYPE, 'name', params.data.lob, params.data.FBA)
        }
      },
      { headerName: 'ETD', field: 'ETD', width: 120, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: 'ETA', field: 'ETA', width: 120, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: 'ATD', field: 'ATD', width: 120, hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: 'ATA', field: 'ATA', width: 120, hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'BUSINESS_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      },
      {
        headerName: this.$t('SeaExport.AirlinePerson2'),
        field: 'PLANNER',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        width: 180
      },
      {
        headerName: this.$t('SeaExport.SalesOfGoods'),
        field: 'CARGO_SALES_ID',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales')
        },
        width: 180
      },
      { headerName: this.$t('CargoMsg.Cargo_FinancialDate'), field: 'ACCOUNTING_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        } },
      { headerName: this.$t('CargoMsg.Cargo_BillDate'), field: 'INPUTDATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        } },
      { headerName: this.$t('CargoMsg.Cargo_Space2'), field: 'INVOICEDATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        } },
      { headerName: this.$t('CargoMsg.Cargo_PayReceiveDate'), field: 'PAY_RECEIVE_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        } },
      { headerName: this.$t('CargoMsg.Cargo_WriteOffDate'), field: 'CLEARING_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        } },
      { headerName: this.$t('CargoMsg.Cargo_UnitPrice'), field: 'UNIT_RATE', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        } },
      { headerName: this.$t('CargoMsg.Cargo_AmountNumber'), field: 'QUANTITY', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_AccountPeriodDay'), field: 'CREDIT_DATE_LIMITED', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_ContainerNo'), field: 'CONTAINER_NO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_WriteOffSerialNumber'), field: 'ACTUALAMOUNT_NO', width: 180 },
      { headerName: this.$t('SeaExport.ContainerDescription'), field: 'CONTAINER_DESC', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.containerDescLabelFuncForChargeSearch(params.value)
        },
        filter: false,
        filterParams: {}
      },
      { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'USER_DEFINED_FIELD_1', width: 180, enableRowGroup: true },
      { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'USER_DEFINED_FIELD_2', width: 180, enableRowGroup: true },
      { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'USER_DEFINED_FIELD_3', width: 180, enableRowGroup: true },
      { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'USER_DEFINED_FIELD_4', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'REMARKS', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_ExchangeRate2'), field: 'EXCHANGE_RATE', width: 180, hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 8)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_ConversionRMB'), field: 'CONVERT_TO_RMB', width: 180, hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        },
        summaryMode: 'sum'
      },
      { headerName: this.$t('CargoMsg.Cargo_OperationDate'), field: 'CUSTOMS_DATE', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.WarehouseNo'),
        field: 'WAREHOUSE_NO',
        hide: true,
        enableRowGroup: true,
        width: 180
      }, { headerName: this.$t('CargoMsg.Cargo_AccrualDate'), field: 'PROVISIONED_DATE', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_JobAccrualDate'), field: 'JOB_PROVISIONED_DATE', width: 180, hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('SeaExport.DateOfDelivery'), field: 'DELIVER_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      },
      { headerName: this.$t('SeaExport.DateOfArrivalTheWarehouse'), field: 'ARRIVE_STORAGE_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      },
      { headerName: this.$t('Payment.paymentPeriod'), field: 'DEADLINE', width: 180, hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_CustomerService'), field: 'CSR_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('SeaExport.FLCLType'),
        field: 'CONTAINER_LOAD_TYPE',
        hide: true,
        filter: false,
        enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'CONTAINER_LOAD_TYPE')
        },
        width: 150
      },
      {
        headerName: this.$t('SeaExport.OperateType'),
        field: 'OPERATE_TYPE',
        hide: true,
        filter: false,
        valueFormatter: (params) => {
          return ColumnUtils.operateTypeLabelFunc(params.data, 'OPERATE_TYPE')
        },
        width: 150
      },
      { headerName: this.$t('CargoMsg.Cargo_BusinessType'), field: 'lob', width: 100, hide: true, enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.jobBussStateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_Carrier'), field: 'CARRIER_ID', width: 100, hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_Airline'),
        field: 'airLine', width: 100,
        valueFormatter: (params) => {
          return ColumnUtils.airLineLabelFunction(params.data, 'airLine')
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.airLineLabelFunction(params.data, 'airLine')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_Operation'), colId: 'jobOp', field: 'jobOp', enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
        field: 'OP_DEPARTMENT',
        width: 180,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
        },
        hide: true
      },
      {
        headerName: this.$t('WriteOff.accountStatementNo'),
        field: 'billingGroupBillingNo',
        enableRowGroup: true,
        width: 180
      },
      { headerName: this.$t('CargoMsg.Cargo_chargeUpdater'), colId: 'changer', field: 'changer',
        width: 180,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_Documents'), field: 'DC_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('Billing.DueDate'), colId: 'dueDate', field: 'dueDate', width: 120, hide: true, enableRowGroup: true,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
        field: 'khPlateNumber',
        colId: 'khPlateNumber',
        width: 120,
        enableRowGroup: true,
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
        field: 'khTrailerNumber',
        colId: 'khTrailerNumber',
        width: 120,
        enableRowGroup: true,
        hide: true
      },
      { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'PONO', width: 180, hide: true, enableRowGroup: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_DelegationTypeRailway'),
        field: 'R_CONTAINER_LOAD_TYPE',
        hide: true,
        filter: false,
        valueFormatter: (params) => {
          return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'R_CONTAINER_LOAD_TYPE')
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
        field: 'BOOKING_AGENT',
        colId: 'BOOKING_AGENT',
        width: 180,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_ShippingCompanyContractNo'),
        field: 'SC_NO',
        colId: 'SC_NO',
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
        field: 'DISCHARGING_PLACE',
        colId: 'DISCHARGING_PLACE',
        enableRowGroup: true,
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
        field: 'ACT_TAKE_TIME',
        colId: 'ACT_TAKE_TIME',
        enableRowGroup: true,
        width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
        field: 'salesDept',
        colId: 'salesDept',
        enableRowGroup: true,
        width: 180,
        hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_DepartureStation'),
        colId: 'departureStation',
        field: 'departureStation',
        hide: true,
        enableRowGroup: true,
        cellRenderer: params => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
        },
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_DestinationStation'),
        colId: 'destinationStation',
        field: 'destinationStation',
        hide: true,
        enableRowGroup: true,
        cellRenderer: params => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
        },
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_TransitStation'),
        colId: 'transitStation',
        field: 'transitStation',
        hide: true,
        enableRowGroup: true,
        cellRenderer: params => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
        },
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_TransferStation'),
        colId: 'transferStation',
        field: 'transferStation',
        hide: true,
        enableRowGroup: true,
        cellRenderer: params => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
        },
        width: 120
      },
      {
        headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
        colId: 'receivableInvoiceState',
        field: 'receivableInvoiceState',
        width: 180,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
        },
        hide: true
      },
      {
        headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
        colId: 'payableInvoiceState',
        field: 'payableInvoiceState',
        width: 180,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
        },
        hide: true
      },
      { headerName: this.$t('CargoMsg.Cargo_AdvanceChargeInfo'),
        field: 'ADVANCE',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        }, width: 100, hide: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ContractRateProperty'),
        colId: 'bookingTerm',
        field: 'bookingTerm',
        width: 180,
        enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.bookingTermSILabelFunction(params.data, params.value)
        },
        hide: true
      },
      {
        headerName: this.$t('SeaExport.FeeCreationDate'),
        field: 'dateCreated',
        enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        initialWidth: 150,
        hide: true
      },
      {
        headerName: this.$t('Payment.adjustedOrNot'), colId: 'adjustment', field: 'adjustment', initialWidth: 150, enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        filter: false,
        filterParams: {},
        hide: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_CloudPlatformSyncStatus'),
        colId: 'jdyxkSyncStatus',
        field: 'jdyxkSyncStatus',
        initialWidth: 100,
        enableRowGroup: true,
        valueFormatter: (params) => {
          if (!params.value) {
            return ColumnUtils.jdyxkSyncStatusLabelFunc(0)
          }
          return ColumnUtils.jdyxkSyncStatusLabelFunc(Number(params.value))
        },
        hide: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ChargeSyncStatus'),
        colId: 'syncStatus',
        field: 'syncStatus',
        initialWidth: 180,
        hide: true,
        enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        }
      },
      {
        headerName: this.$t('Payment.theAmountOfWriteOffs'),
        field: 'chargeVerifiedAmount',
        colId: 'chargeVerifiedAmount',
        width: 110,
        hide: true,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return Number(params.value).toFixed(2)
        }
      },
      {
        headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'oversea',
        field: 'oversea',
        initialWidth: 100,
        hide: true,
        enableRowGroup: true,
        valueFormatter: (params) => {
          return stringToBool(params.value) ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_ActualGrossWeight'), field: 'weightActual', width: 100, hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return params.value || ''
        },
        summaryMode: 'sum'
      },
      { headerName: this.$t('CargoMsg.Cargo_ActualChargedWeight'), field: 'chargeWeight', width: 100, hide: true,
        cellRenderer: (params) => {
          return this.getChargeWeight(params)
        },
        filterParams: {},
        filterValueGetter: (params) => {
          if (params.data.lob === 'AE') {
            return params.data.cWeight || ''
          }
          if (params.data.lob === 'RE' || params.data.lob === 'RI') {
            return ''
          }
          return params.data.chargeWeight || ''
        },
        summaryMode: 'sum'
      },
      {
        headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'OVERSEA_OP', width: 180, colId: 'OVERSEA_OP', hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('Invoice.invoice_feeStatus'),
        field: 'chargeState',
        width: 120,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.chargeStateLabFun(Number(params.value))
        },
        hide: true
      },
      {
        headerName: this.$t('FinanceManage.Peer'), field: 'peer', width: 100, colId: 'peer', hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.PortOfDischargeSeaAndComprehensive'),
        colId: 'DISCHARGING_PORT_CODE',
        field: 'DISCHARGING_PORT_CODE',
        enableRowGroup: true,
        hide: true,
        valueGetter: (params) => {
          return ColumnUtils.portLabelFuncBySeaAndComprehensive(params.data, params.data.DISCHARGING_PORT_CODE)
        },
        width: 170
      }, {
        headerName: this.$t('SeaExport.DestinationPortCountry'),
        colId: 'DESTINATION_PORT_COUNTRY_CODE',
        field: 'DESTINATION_PORT_COUNTRY_CODE',
        enableRowGroup: true,
        hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, this.isZh ? 'chineseName' : 'name')
        },
        width: 170
      }, {
        headerName: this.$t('SeaExport.DischargingPortCountry'),
        colId: 'DISCHARGING_PORT_COUNTRY_CODE',
        field: 'DISCHARGING_PORT_COUNTRY_CODE',
        enableRowGroup: true,
        hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, this.isZh ? 'chineseName' : 'name')
        },
        width: 170
      },
      { headerName: this.$t('CargoMsg.Cargo_ChargeInvoiceTitle'), field: 'invoiceTitle', width: 120, enableRowGroup: true },
      { headerName: this.$t('Payment.separateNumber'), field: 'HBL', initialWidth: 200, enableRowGroup: true },
      {
        headerName: this.$t('Billing.billingCharge_bookingNo'),
        field: 'bookingNo',
        colId: 'bookingNo',
        width: 200,
        hide: true,
        enableRowGroup: true
      },
      { headerName: this.$t('CargoMsg.Cargo_WriteOffPerson'), field: 'verificationBy', colId: 'verificationBy', width: 100, hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      }
    ]
  },
  methods: {
    onCheckBoxClick(event) {
      const selections = getGridSelected(this.gridOptions)
      this.numSelected = selections.length
      if (selections.length > 0) {
        this.loading = getLoading()
        // this.$refs.sumChargeReceivable.setDataProvider(selections, event)
        // this.$refs.sumChargePayable.setDataProvider(selections, event)
        // this.$refs.sumChargeNotReceived.setDataProvider(selections, event)
        // this.$refs.sumChargeUnpaid.setDataProvider(selections, event)
        this.$refs.sumJobEquivalentRMB.setDataProvider(selections)
        this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(selections)
        this.$refs.sumJobRmbEquivalentPayable.setDataProvider(selections)
        this.dataProvider = selections
        this.loading.close()
      } else {
        this.$nextTick(() => {
          this.loading = getLoading()
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.data && node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.rowData.length) {
              // this.$refs.sumChargeReceivable.setDataProvider(this.rowData, event)
              // this.$refs.sumChargePayable.setDataProvider(this.rowData, event)
              // this.$refs.sumChargeNotReceived.setDataProvider(this.rowData, event)
              // this.$refs.sumChargeUnpaid.setDataProvider(this.rowData, event)
              this.$refs.sumJobEquivalentRMB.setDataProvider(this.rowData)
              this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(this.rowData)
              this.$refs.sumJobRmbEquivalentPayable.setDataProvider(this.rowData)
              this.dataProvider = this.rowData
            }
            if (hasDisplay.length < this.rowData.length) {
              // this.$refs.sumChargeReceivable.setDataProvider(hasDisplay, event)
              // this.$refs.sumChargePayable.setDataProvider(hasDisplay, event)
              // this.$refs.sumChargeNotReceived.setDataProvider(hasDisplay, event)
              // this.$refs.sumChargeUnpaid.setDataProvider(hasDisplay, event)
              this.$refs.sumJobEquivalentRMB.setDataProvider(hasDisplay)
              this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(hasDisplay)
              this.$refs.sumJobRmbEquivalentPayable.setDataProvider(hasDisplay)
              this.dataProvider = hasDisplay
            }
          } else {
            // this.$refs.sumChargeReceivable.setDataProvider(hasDisplay, event)
            // this.$refs.sumChargePayable.setDataProvider(hasDisplay, event)
            // this.$refs.sumChargeNotReceived.setDataProvider(hasDisplay, event)
            // this.$refs.sumChargeUnpaid.setDataProvider(hasDisplay, event)
            this.$refs.sumJobEquivalentRMB.setDataProvider(hasDisplay)
            this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(hasDisplay)
            this.$refs.sumJobRmbEquivalentPayable.setDataProvider(hasDisplay)
            this.dataProvider = hasDisplay
          }
          this.loading.close()
        })
      }
    },
    onSumCallbak(data) {
      this.showSumPop = data.showPop
      this.arCurrencySum = data.arCurrencySum
      this.apCurrencySum = data.apCurrencySum
    },
    getChargeWeight(params) {
      if (params.data.lob === 'AE') {
        return params.data.cWeight || ''
      }
      if (params.data.lob === 'RE' || params.data.lob === 'RI') {
        return ''
      }
      return params.value || ''
    },
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    }
  }
}
</script>

<style scoped>

</style>
